var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.datamodel.value),function(item,index){return _c('div',{key:item.type+index},[(_vm.registerTemplateName_SAVE.includes(`C${item.type.replace(/-/g, '')}`))?[(item.value && item.visible)?_c(`C${item.type.replace(/-/g, '')}`,{ref:"childComponents",refInFor:true,tag:"component",attrs:{"datamodel":item}}):_c('div')]:_vm._e()],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }